import React, { useEffect, useState } from 'react';
import "./manageusers.css";
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import toast from 'react-hot-toast';
import HttpClient from '../utils/HttpClient';
import "./manageusers.css";
import Swal from 'sweetalert2';
import { Dropdown } from 'react-bootstrap';

const ManageProjectItems = () => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [activeRow, setActiveRow] = useState(null);
    const [allItemsList, setAllItemsList] = useState([]);
    const [selectedItemsId, setSelectedItemsId] = useState("")

    // >>>>Fetch All Items Data<<<<
    const fetchAllItems = async () => {
        const res = await HttpClient.requestData("project-item", "GET");
        if (res && res?.status) {
            const arr = res?.data?.map((ele, ind) => ({
                sl: ind + 1,
                itemName: ele?.itemName,
                type: ele?.type, 
                status: ele?.status === "Active" ? <p style={{ color: "#33614C", fontWeight: "bold" }}>{ele?.status}</p> : <p style={{ color: "#bda800", fontWeight: "bold" }}>{ele?.status}</p>,
                action: ele,
            }));

            setAllItemsList(arr);
        } else {
            toast.error("Failed to fetch user data.");
        }
    };

    // Columns Definition
    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            sortable: true,
            wrap: true
        },
        {
            name: 'Item-Name',
            selector: row => row.itemName,
            sortable: true,
            wrap: true
        },
        {
            name: 'Graph-Type',
            selector: row => row.type,
            sortable: true,
            wrap: true
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            wrap: true
        },
        {
            name: 'Action',
            cell: row => (
                <Dropdown>
                    <Dropdown.Toggle variant="link" id="dropdown-basic" style={{ border: 'none', boxShadow: 'none', textDecoration: "none", color: "rgb(208, 38, 38)" }}>
                        <i className="fa-solid fa-ellipsis-v" style={{ cursor: 'pointer' }} onClick={() => handleIconClick(row.sl)}></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="tooltip-modal">
                        <Dropdown.Item className='tooltipBtn' onClick={() => handleEdit(row)}>Edit</Dropdown.Item>
                        <Dropdown.Item className='tooltipBtn' onClick={() => handleDelete(row)}>Delete</Dropdown.Item>
                        <Dropdown.Item className='tooltipBtn' onClick={() => handleActiveInactive(row, row?.action?.status === "Active" ? "Inactive" : "Active")}>{row.action?.status === "Active" ? "Inactive" : "Active"}</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            ),
            sortable: false,
            wrap: true,
        },
    ];

    // >>>>Search items by their name<<<<
    // const searchUser = allItemsList.filter(data =>
    //     data?.itemName?.toLowerCase()?.includes(searchQuery.toLowerCase())
    // );

    // >>>>Handle Showing Menu Modal<<<<
    const handleIconClick = (rowId) => {
        if (activeRow === rowId) {
            setActiveRow(null);
        } else {
            setActiveRow(rowId);
        }
    };

    // >>>>Handle Edit Items<<<<
    const handleEdit = (row) => {
        navigate('/itemview', { state: row?.action })
    };


    // >>>>Handle Delete with SweetAlert confirmation<<<<
    const handleDelete = async (row) => {
        const id = row?.action?._id;
        if (id) {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            });

            if (result.isConfirmed) {
                const res = await HttpClient.requestData(`project-item/${id}`, "DELETE");
                if (res && res.status) {
                    toast.success("Item deleted successfully.");
                    fetchAllItems();
                    setActiveRow(null)
                } else {
                    toast.error("Failed to delete item.");
                }
            }
        }
    };

    // >>>>Handle Activ/Imactive items<<<<
    const handleActiveInactive = async (row, rowStatus) => {
        const id = row?.action?._id
        if (id && rowStatus) {
            const data = {
                status: rowStatus
            }
            console.log("Toggldfgdx", row, id, data);
            const res = await HttpClient.requestData(`project-item-status/${id}`, "PUT", data);
            if (res && res?.status) {
                toast.success(res?.message || "Status updated successfully...!");
                fetchAllItems()
                setActiveRow(null)
            } else {
                return toast.error(res?.message || "Something went wrong...!")
            }
        }
    };

    useEffect(() => {
        fetchAllItems()
    }, [])

    return (
        <div className='manageUsers' style={{ position: 'relative' }}>
            {/* Heading */}
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 0' }}>
                <h3 style={{ fontSize: '20px' }}>Manage Items</h3>
                <h3 style={{ fontSize: '15px', color: 'rgb(208, 38, 38)', cursor: 'pointer' }} onClick={() => navigate('/itemview')}>+ Add Items</h3>
            </div>

            {/* Search Input */}
            <div className="header-container Search_box d-flex justify-content-start p-2">
                <form className="form-inline" style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)" }} onSubmit={(e) => e.preventDefault()}>
                    <input
                        className="form-control"
                        type="search"
                        placeholder="Search by item name..."
                        aria-label="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button className="Search_icon" type="submit">
                        <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                </form>
            </div>


            {/* DataTable */}
            <div className='mt-2 shadow-lg'>
                <DataTable
                    columns={columns}
                    data={allItemsList}
                    pagination={true}
                    responsive={true}
                    highlightOnHover={true}
                />
            </div>

        </div>
    );
}

export default ManageProjectItems;
